(function () {
  "use strict";

  var EVENTS_URL = (function () {
    /*
     * 接口环境由 Liquid 注入到 script[data-events-url]。
     * JS 只读取配置，不自行判断当前主题是否在线。
     */
    if (
      typeof document !== "undefined" &&
      document.currentScript
    ) {
      var configuredUrl = document.currentScript.getAttribute(
        "data-events-url",
      );

      if (/^https:\/\//i.test(configuredUrl || "")) {
        return configuredUrl;
      }
    }

    return "https://api.bluettipower.com/integrationapi/policy/consents";
  })();

  var SDK_VERSION = "1.0.0";
  var MAX_PRIVACY_API_ATTEMPTS = 50;
  var PRIVACY_API_RETRY_MS = 100;
  var MAX_CONSENT_ID_ATTEMPTS = 10;
  var CONSENT_ID_RETRY_MS = 100;

  var INSTALL_FLAG = "__bluettiPrivacyConsentListenerInstalled__";

  var privacyApi = null;
  var pendingConsentEvents = [];
  var sendQueue = Promise.resolve();
  var initialLoadReported = false;

  /*
   * 防止主题重复加载脚本，导致重复注册监听器和重复上报。
   */
  if (window[INSTALL_FLAG]) {
    return;
  }

  window[INSTALL_FLAG] = true;

  function loadPrivacyApi(attempt) {
    if (window.Shopify && window.Shopify.customerPrivacy) {
      return Promise.resolve(window.Shopify.customerPrivacy);
    }

    if (
      window.Shopify &&
      typeof window.Shopify.loadFeatures === "function"
    ) {
      return new Promise(function (resolve, reject) {
        window.Shopify.loadFeatures(
          [
            {
              name: "consent-tracking-api",
              version: "0.1",
            },
          ],
          function (error) {
            if (error) {
              reject(
                new Error(
                  error.message ||
                  "Shopify Customer Privacy API failed to load",
                ),
              );
              return;
            }

            if (!window.Shopify.customerPrivacy) {
              reject(
                new Error("Shopify Customer Privacy API is unavailable"),
              );
              return;
            }

            resolve(window.Shopify.customerPrivacy);
          },
        );
      });
    }

    if (attempt >= MAX_PRIVACY_API_ATTEMPTS) {
      return Promise.reject(
        new Error("Shopify Customer Privacy API is unavailable"),
      );
    }

    return new Promise(function (resolve, reject) {
      window.setTimeout(function () {
        loadPrivacyApi(attempt + 1).then(resolve, reject);
      }, PRIVACY_API_RETRY_MS);
    });
  }

  function reportFailure(scope, error) {
    if (
      !window.console ||
      typeof window.console.warn !== "function"
    ) {
      return;
    }

    var message =
      error && error.message
        ? error.message
        : String(error || "Unknown error");

    window.console.warn(
      "[Privacy Consent] " + scope + " failed: " + message,
    );
  }

  function consentValue(value) {
    /*
     * Shopify 返回的 yes/no 是字符串。
     * 上报时保持原始字符串类型，不转换成 boolean。
     */
    if (value === "yes" || value === "no") {
      return value;
    }

    return null;
  }

  function readConsentId(api) {
    try {
      return Promise.resolve(
        typeof api.consentId === "function"
          ? api.consentId()
          : null,
      ).catch(function () {
        return null;
      });
    } catch (_error) {
      return Promise.resolve(null);
    }
  }

  function readConsentIdWithRetry(api, shouldRetry, attempt) {
    return readConsentId(api).then(function (consentId) {
      if (
        (typeof consentId === "string" &&
          consentId.trim()) ||
        !shouldRetry ||
        attempt >= MAX_CONSENT_ID_ATTEMPTS - 1
      ) {
        return consentId;
      }

      /*
       * consentId 来自 Shopify 的 consent cookie。
       * 在真实浏览器中，visitorConsentCollected 与 cookie/API 完成写入
       * 之间可能有很短的时间差，因此同意变更后做有限重试。
       */
      return new Promise(function (resolve) {
        window.setTimeout(resolve, CONSENT_ID_RETRY_MS);
      }).then(function () {
        return readConsentIdWithRetry(
          api,
          shouldRetry,
          attempt + 1,
        );
      });
    });
  }

  function readShopHandle() {
    var shop =
      window.Shopify && typeof window.Shopify.shop === "string"
        ? window.Shopify.shop
        : "";

    if (!shop) {
      return "";
    }

    /*
     * bluetti-develop.myshopify.com
     * ->
     * bluetti-develop
     */
    return shop.replace(/\.myshopify\.com$/i, "");
  }

  function readLanguage() {
    if (
      typeof document === "undefined" ||
      !document.documentElement
    ) {
      return "";
    }

    var language = document.documentElement.lang;

    if (typeof language !== "string") {
      return "";
    }

    /*
     * 防止 Header 值中出现换行，并限制长度。
     */
    return language
      .replace(/[\r\n]/g, "")
      .trim()
      .slice(0, 64);
  }

  function readUserAgent() {
    if (
      typeof navigator === "undefined" ||
      typeof navigator.userAgent !== "string"
    ) {
      return "";
    }

    return navigator.userAgent
      .replace(/[\r\n]/g, "")
      .slice(0, 1024);
  }

  function matchUserAgentValue(userAgent, pattern) {
    var match = userAgent.match(pattern);

    if (!match || !match[1]) {
      return "";
    }

    return match[1]
      .replace(/[\r\n]/g, "")
      .trim()
      .slice(0, 64);
  }

  function readDevice() {
    var userAgent = readUserAgent();
    var browserName = "";
    var browserVersion = "";
    var osName = "";
    var osVersion = "";
    var deviceModel = "";
    var deviceType = "";

    if (!userAgent) {
      return {
        userAgent: "",
        browserName: null,
        browserVersion: null,
        deviceType: null,
        deviceModel: null,
        osName: null,
        osVersion: null,
      };
    }

    browserVersion = matchUserAgentValue(
      userAgent,
      /(?:EdgA|EdgiOS|Edg|Edge)\/([\d.]+)/i,
    );

    if (browserVersion) {
      browserName = "Edge";
    } else {
      browserVersion = matchUserAgentValue(
        userAgent,
        /SamsungBrowser\/([\d.]+)/i,
      );

      if (browserVersion) {
        browserName = "Samsung Internet";
      } else {
        browserVersion = matchUserAgentValue(
          userAgent,
          /(?:OPR|Opera)\/([\d.]+)/i,
        );

        if (browserVersion) {
          browserName = "Opera";
        } else {
          browserVersion = matchUserAgentValue(
            userAgent,
            /(?:CriOS|Chrome)\/([\d.]+)/i,
          );

          if (browserVersion) {
            browserName = "Chrome";
          } else {
            browserVersion = matchUserAgentValue(
              userAgent,
              /(?:FxiOS|Firefox)\/([\d.]+)/i,
            );

            if (browserVersion) {
              browserName = "Firefox";
            } else {
              browserVersion = matchUserAgentValue(
                userAgent,
                /Version\/([\d.]+).*Safari\//i,
              );

              if (browserVersion) {
                browserName = "Safari";
              }
            }
          }
        }
      }
    }

    var iosVersion = matchUserAgentValue(
      userAgent,
      /OS ([\d_]+) like Mac OS X/i,
    );

    if (iosVersion && /iPhone|iPad|iPod/i.test(userAgent)) {
      osName = "iOS";
      osVersion = iosVersion.replace(/_/g, ".");
    } else {
      osVersion = matchUserAgentValue(
        userAgent,
        /Android\s+([\d.]+)/i,
      );

      if (osVersion) {
        osName = "Android";
      } else {
        osVersion = matchUserAgentValue(
          userAgent,
          /Windows NT\s+([\d.]+)/i,
        );

        if (osVersion) {
          osName = "Windows";
        } else {
          osVersion = matchUserAgentValue(
            userAgent,
            /Mac OS X\s*([\d_\.]+)?/i,
          );

          if (osVersion && !/iPhone|iPad|iPod/i.test(userAgent)) {
            osName = "macOS";
            osVersion = osVersion.replace(/_/g, ".");
          } else {
            osVersion = "";

            if (/Linux/i.test(userAgent)) {
              osName = "Linux";
            }
          }
        }
      }
    }

    if (/iPad/i.test(userAgent)) {
      deviceModel = "iPad";
      deviceType = "tablet";
    } else if (/iPhone/i.test(userAgent)) {
      deviceModel = "iPhone";
      deviceType = "mobile";
    } else if (/iPod/i.test(userAgent)) {
      deviceModel = "iPod";
      deviceType = "mobile";
    } else if (/Android/i.test(userAgent)) {
      deviceType = /Mobile/i.test(userAgent)
        ? "mobile"
        : "tablet";

      deviceModel = matchUserAgentValue(
        userAgent,
        /Android[^;)]*;\s*(?:[^;]+;\s*)?([^;)]+?)(?:\s+Build\/[^;)]+)?[;)]/i,
      );
    } else if (/Mobi/i.test(userAgent)) {
      deviceType = "mobile";
    } else {
      deviceType = "desktop";
    }

    if (!deviceModel && /Macintosh/i.test(userAgent)) {
      deviceModel = "Mac";
    }

    return {
      userAgent: userAgent,
      browserName: browserName || null,
      browserVersion: browserVersion || null,
      deviceType: deviceType || null,
      deviceModel: deviceModel || null,
      osName: osName || null,
      osVersion: osVersion || null,
    };
  }

  function readPage() {
    var path = "";

    if (
      typeof window !== "undefined" &&
      window.location &&
      typeof window.location.pathname === "string"
    ) {
      path = window.location.pathname
        .replace(/[\r\n]/g, "")
        .slice(0, 512);
    }

    var language = readLanguage();
    var locale = language
      ? language.split(/[-_]/)[0].toLowerCase()
      : "";

    if (!locale) {
      var localeFromPath = path.match(
        /^\/([a-z]{2})(?:[-_\/]|$)/i,
      );

      locale = localeFromPath
        ? localeFromPath[1].toLowerCase()
        : "";
    }

    return {
      path: path,
      locale: locale || null,
    };
  }

  function readCurrentVisitorConsent(api) {
    try {
      if (
        typeof api.currentVisitorConsent !== "function"
      ) {
        return {};
      }

      return api.currentVisitorConsent() || {};
    } catch (_error) {
      return {};
    }
  }

  function readRegion(api) {
    try {
      if (typeof api.getRegion !== "function") {
        return "";
      }

      return api.getRegion() || "";
    } catch (_error) {
      return "";
    }
  }

  function readGpcSignal() {
    return Boolean(
      typeof navigator !== "undefined" &&
      navigator.globalPrivacyControl === true,
    );
  }

  function readState(api, eventType) {
    var current = readCurrentVisitorConsent(api);

    var state = {
      consent: {
        analytics: consentValue(current.analytics),
        marketing: consentValue(current.marketing),
        preferences: consentValue(current.preferences),
        saleOfData: consentValue(current.sale_of_data),
      },

      consentId: null,

      region: readRegion(api) || null,

      /*
       * 这里只记录 GPC 信号是否存在，
       * 不把它当成当前事件的来源。
       */
      gpcDetected: readGpcSignal(),
    };

    var hasRecordedConsent = Object.keys(state.consent).some(
      function (purpose) {
        return state.consent[purpose] !== null;
      },
    );

    return readConsentIdWithRetry(
      api,
      eventType === "CONSENT_CHANGED" || hasRecordedConsent,
      0,
    ).then(function (consentId) {
      if (
        typeof consentId === "string" &&
        consentId.trim()
      ) {
        state.consentId = consentId.trim();
      }

      return state;
    });
  }

  function createEventId() {
    if (
      window.crypto &&
      typeof window.crypto.randomUUID === "function"
    ) {
      return window.crypto.randomUUID();
    }

    if (
      window.crypto &&
      typeof window.crypto.getRandomValues === "function"
    ) {
      var bytes = new Uint8Array(16);

      window.crypto.getRandomValues(bytes);

      bytes[6] = (bytes[6] & 0x0f) | 0x40;
      bytes[8] = (bytes[8] & 0x3f) | 0x80;

      var hex = [];

      for (var i = 0; i < bytes.length; i += 1) {
        hex.push(("00" + bytes[i].toString(16)).slice(-2));
      }

      return (
        hex.slice(0, 4).join("") +
        "-" +
        hex.slice(4, 6).join("") +
        "-" +
        hex.slice(6, 8).join("") +
        "-" +
        hex.slice(8, 10).join("") +
        "-" +
        hex.slice(10, 16).join("")
      );
    }

    /*
     * 仅作为极老旧浏览器的降级方案。
     * 服务端仍应使用 eventId 去重，不能把它当作安全凭证。
     */
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
      /[xy]/g,
      function (character) {
        var random = (Math.random() * 16) | 0;
        var value =
          character === "x"
            ? random
            : (random & 3) | 8;

        return value.toString(16);
      },
    );
  }

  function sendEvent(api, eventType) {
    return readState(api, eventType).then(function (state) {
      /*
       * 数据库只接收已经在 Shopify 中形成 consent 记录的事件。
       * 首次访问且用户尚未作出选择时，consentId 不存在，跳过本次上报，
       * 避免把空的 INITIAL_LOAD 写入数据库。
       */
      if (!state.consentId) {
        return;
      }

      var shop = readShopHandle();
      var language = readLanguage();

      var headers = {
        "Content-Type": "application/json",
      };

      /*
       * 示例：
       * shop: bluetti-develop
       * language: en
       */
      if (shop) {
        headers.shop = shop;
      }

      if (language) {
        headers.language = language;
      }

      var body = {
        schemaVersion: 1,

        eventId: createEventId(),

        /*
         * visitorConsentCollected 表示隐私状态发生了变化，
         * 不在这里推断具体是 GPC 还是数据出售退出。
         */
        eventType: eventType || "CONSENT_CHANGED",

        source: "SHOPIFY_CUSTOMER_PRIVACY_EVENT",

        consent: state.consent,

        device: readDevice(),

        page: readPage(),

        consentId: state.consentId,

        region: state.region,

        gpcDetected: state.gpcDetected,

        sdkVersion: SDK_VERSION,

        /*
         * 这是客户端时间。
         * 服务端应另外记录 receivedAt。
         */
        occurredAt: new Date().toISOString(),
      };

      return fetch(EVENTS_URL, {
        method: "POST",

        /*
         * 当前使用的是外部 API URL，不是 Shopify App Proxy。
         */
        mode: "cors",

        /*
         * 不向外部 API 发送 Shopify storefront Cookie。
         */
        credentials: "omit",

        headers: headers,

        body: JSON.stringify(body),

        /*
         * 页面关闭时尽量继续发送请求。
         */
        keepalive: true,
      })
        .then(function (response) {
          if (!response.ok) {
            throw new Error(
              "Privacy Consent event request failed (HTTP " +
              response.status +
              ")",
            );
          }
        })
        .catch(function (error) {
          /*
           * 上报失败不影响 storefront 正常使用。
           */
          reportFailure("event sync", error);
        });
    });
  }

  function queueEvent(eventType) {
    if (!privacyApi) {
      pendingConsentEvents.push(eventType || "CONSENT_CHANGED");
      return;
    }

    /*
     * 串行发送，避免用户快速连续修改时请求乱序。
     */
    sendQueue = sendQueue
      .then(function () {
        return sendEvent(
          privacyApi,
          eventType || "CONSENT_CHANGED",
        );
      })
      .catch(function (error) {
        reportFailure("queued event", error);
      });
  }

  function flushPendingConsentEvents() {
    var events = pendingConsentEvents;

    pendingConsentEvents = [];

    events.forEach(function (eventType) {
      queueEvent(eventType);
    });
  }

  function queueInitialLoadEvent() {
    if (initialLoadReported) {
      return;
    }

    initialLoadReported = true;

    /*
     * 首次加载也上报一次当前隐私状态。
     * sendEvent 会通过 Customer Privacy API 重新读取最新状态。
     */
    sendQueue = sendQueue
      .then(function () {
        return sendEvent(privacyApi, "INITIAL_LOAD");
      })
      .catch(function (error) {
        reportFailure("initial load", error);
      });
  }

  function handleConsentCollected() {
    /*
     * 即使 Customer Privacy API 还没有加载完成，
     * 也先保存 Shopify 已经派发的事件。
     */
    queueEvent("CONSENT_CHANGED");
  }

  function start() {
    /*
     * 必须尽早注册监听器，避免 API 加载期间漏掉事件。
     */
    document.addEventListener(
      "visitorConsentCollected",
      handleConsentCollected,
    );

    loadPrivacyApi(0)
      .then(function (api) {
        privacyApi = api;

        flushPendingConsentEvents();
        queueInitialLoadEvent();
      })
      .catch(function (error) {
        /*
         * Customer Privacy API 不可用时，不发送未知状态。
         */
        reportFailure("startup", error);
      });
  }

  start();
})();
